import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import { InheritanceHelper } from "%/dynamic-component-editor/classes/inheritance-helper";
import StaticLayoutDirection from "%/dynamic-component-editor/options/static-layout-direction";

export default class LayoutAlignVertical extends BaseOption {
  static label = "Vertical Align";

  static userInterfaceComponent = (optionsConfig, themeId, state) => {
    let layoutDirection = "vertical";
    if (state) {
      layoutDirection = InheritanceHelper.getInheritedOptionValue(new StaticLayoutDirection(), state, optionsConfig);
    }

    let options = [
      {
        icon: "position-top",
        value: "start",
      },
      {
        icon: "position-middle-vertical",
        value: "center",
      },
      {
        icon: "position-bottom",
        value: "end",
      },
      {
        icon: "position-between-vertical",
        value: "between",
      },
      {
        icon: "position-around-vertical",
        value: "around",
      },
      {
        icon: "position-evenly-vertical",
        value: "evenly",
      },
    ];

    if (layoutDirection === "horizontal") {
      options = [
        {
          icon: "position-left",
          value: "start",
        },
        {
          icon: "position-middle-horizontal",
          value: "center",
        },
        {
          icon: "position-right",
          value: "end",
        },
        {
          icon: "position-between-horizontal",
          value: "between",
        },
        {
          icon: "position-around-horizontal",
          value: "around",
        },
        {
          icon: "position-evenly-horizontal",
          value: "evenly",
        },
      ];
    }

    return {
      component: inspectorTools.RADIO_BAR,
      iconSize: 24,
      props: {
        options,
      },
    };
  };

  static defaultValue = "start";

  static getValue(option) {
    let value = option;

    if (typeof option !== "string") {
      value = option.value;
    }

    return value;
  }
}
